import { render } from "./FooterVue.vue?vue&type=template&id=440f8fbe&scoped=true"
const script = {}

import "./FooterVue.vue?vue&type=style&index=0&id=440f8fbe&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/data/workspace/gym-official-web_prod/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-440f8fbe"]])

export default __exports__